/* eslint-disable ember/no-observers, no-unused-vars */
import Helper from '@ember/component/helper';

// Components rendered side-by-side when adjacent in the configuration.
const ROW_TYPES = ['next-steps', 'help-at-home'];

// Component types that render in the section body. Other types
// (section-title, effort, progress-descriptor) are rendered elsewhere.
const BODY_TYPES = [
  'paragraph',
  'teacher-comment',
  'next-steps',
  'help-at-home',
  'progress-visual',
  'strand-visual',
  'assessment-data',
];

function typeOf(comp) {
  if (!comp) return null;
  return comp.type != null ? comp.type : comp.get && comp.get('type');
}

function parseConfig(section) {
  let config = section.get
    ? section.get('configuration')
    : section.configuration;
  if (!config) return { components: [] };
  if (typeof config === 'string') {
    try {
      return JSON.parse(config);
    } catch (e) {
      return { components: [] };
    }
  }
  return config;
}

function buildGroups(section) {
  if (!section) return [];
  let parsed = parseConfig(section);
  let components = (parsed.components || []).filter((c) =>
    BODY_TYPES.includes(typeOf(c)),
  );
  let groups = [];
  let i = 0;
  while (i < components.length) {
    let comp = components[i];
    if (ROW_TYPES.includes(typeOf(comp))) {
      let row = [comp];
      while (
        i + row.length < components.length &&
        ROW_TYPES.includes(typeOf(components[i + row.length]))
      ) {
        row.push(components[i + row.length]);
      }
      groups.push({ kind: 'narrative-row', components: row });
      i += row.length;
    } else {
      groups.push({ kind: 'single', component: comp });
      i += 1;
    }
  }
  return groups;
}

// Class-based helper: function helpers only re-run on argument-reference
// change, but the configurator mutates configuration.components in place
// (DragSortList → removeAt/insertAt). We wire an observer on the components
// array so the helper recomputes when items are reordered, added or removed.
export default class SectionBodyGroups extends Helper {
  compute([section]) {
    this._updateObserver(section);
    return buildGroups(section);
  }

  _updateObserver(section) {
    if (this._observedSection === section) return;
    if (this._observedSection) {
      this._observedSection.removeObserver(
        'configuration.components.[]',
        this,
        this.recompute,
      );
    }
    this._observedSection = section;
    if (section && section.addObserver) {
      section.addObserver('configuration.components.[]', this, this.recompute);
    }
  }

  willDestroy() {
    this._updateObserver(null);
    super.willDestroy(...arguments);
  }
}
